/* eslint-disable consistent-return */
/* eslint-disable no-alert */
import React, { useState, useEffect, useRef, Fragment } from 'react';
import Loader from '../../Common/Loader';
// import { asyncContainer, Typeahead } from 'react-bootstrap-typeahead';

import { AsyncTypeahead } from 'react-bootstrap-typeahead';
// const AsyncTypeahead = asyncContainer(Typeahead);
import axios from 'axios';
import constants from '../../../constants';
import { cookieStorageUtility } from '../../../utils/utilityFunctions';
import { checkRole } from '../../Common/CheckRole';
const { serverUrl, ENCRYPTOR_KEY } = constants;
const authUserId = cookieStorageUtility.fetch('auth_user_id');
const encryptedToken = cookieStorageUtility.fetch('encrypted_' + ENCRYPTOR_KEY + '_token');

const DownloadMapping = (props) => {
  const cityTypeHead = useRef();
  const [showUILoader, setShowUILoader] = useState(false);
  const [showSearchLoader, setShowSearchLoader] = useState(false);
  const [list, setList] = useState({});
  const [countryList, setCountryList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [ota, setOta] = useState([]);
  const [flag, setFlag] = useState(false);
  const [type, setType] = useState('error');
  const [message, setMessage] = useState('');
  const [params, setParams] = useState({
    countryId: 0,
    cityId: 0,
    channelId: 0,
    cityName: ''
  });
  const [total, setTotal] = useState(0);
  const [limit] = useState(20);
  const [pageNumber, setPageNumber] = useState(1);

  useEffect(() => {
    downloadedMappingList();
    getCountrList();
    getOTAList();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    downloadedMappingList();
    // eslint-disable-next-line
  }, [pageNumber]);

  const setMessageHandler = (type, message) => {
    setFlag(true);
    setType(type);
    setMessage(message);
    setTimeout(() => {
      setFlag(false);
    }, 3000);
  };

  const downloadedMappingList = () => {
    const hotelId = cookieStorageUtility.fetch('hotelId');
    setShowUILoader(true);
    axios(serverUrl + 'channel/uploadedmappinglist', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      },
      data: {
        hotelId,
        page: pageNumber,
        limit
      }
    })
      .then(response => {
        if (response.data.status === 'success') {
          setList(response.data.data);
          setTotal(response.data.total);
        } else {
          setMessageHandler('error', response.data.message);
        }
        setShowUILoader(false);
      })
      .catch(error => {
        console.log(error);
        setShowUILoader(false);
      });
  };

  const getOTAList = () => {
    axios(serverUrl + 'common/getotalist', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      }
    })
      .then(response => {
        if (response.status === 200) {
          setOta(response.data);
        } else {
          setMessageHandler('error', response.data.message);
        }
      })
      .catch(error => {
        console.log(error);
        setShowUILoader(false);
      });
  };

  const getCountrList = (countryName) => {
    setShowSearchLoader(true);
    axios(serverUrl + 'common/masterList', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      }
    }).then(response => {
      setShowSearchLoader(false);
      setCountryList(response.data.countryList);
    }).catch(error => {
      console.log(error);
      setShowSearchLoader(false);
    });
  };

  const handleSearchCity = (cityname) => {
    if (typeof cityname === 'undefined' || cityname === '') {
      return;
    }
    if (params.countryId === 0) {
      alert('Please select country first.');
      return;
    }
    if (cityname.length > 2) {
      getCityList(cityname);
    }
  };

  const getCityList = (cityName) => {
    if (props.countryId !== '') {
      setShowSearchLoader(true);
      axios(serverUrl + 'common/cityList', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          token: btoa(authUserId + '|' + encryptedToken)
        },
        data: { cityName: cityName, countryId: params.countryId }
      })
        .then(response => {
          if (response.data.status === 'success') {
            setCityList(response.data.data.cityList);
          } else {
            alert(response.data.message);
            return false;
          }
          setShowSearchLoader(false);
        })
        .catch(error => {
          console.log(error);
          setShowSearchLoader(false);
        });
    }
  };

  const sendRequest = () => {
    const hotelId = cookieStorageUtility.fetch('hotelId');
    if (params.countryId === 0 && params.cityId === 0 && params.channelId === 0) {
      setMessageHandler('error', 'Please select field first.');
      return;
    }
    setShowSearchLoader(true);
    axios(serverUrl + 'channel/downloadmapping', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      },
      data: {
        hotelId,
        ...params
      }
    })
      .then(response => {
        setShowSearchLoader(false);
        if (response.data.status === 'success') {
          setMessageHandler('success', response.data.message);
          downloadedMappingList();
        } else {
          setMessageHandler('error', response.data.message);
          return;
        }
      })
      .catch(error => {
        console.log(error);
        setShowSearchLoader(false);
      });
  };

  const paramChange = (e) => {
    let fieldName = e.target.name;
    setParams(prev => ({ ...prev, [fieldName]: e.target.value }));
  };

  const reset = () => {
    if (cityTypeHead.current && cityTypeHead.current.getInstance) {
      cityTypeHead.current.getInstance().clear();
    }
    setParams({ countryId: 0, cityId: 0, channelId: 0, cityName: '' });
  };

  const handleAsyncCity = (selected) => {
    Object.keys(selected).map(id => {
      setParams(prev => ({
        ...prev,
        cityId: selected[id].city_id,
        cityName: selected[id].state ? selected[id].city + ', ' + selected[id].state : selected[id].city
      }));
    });
  };

  const handlePageChange = (pageNumber) => {
    setPageNumber(pageNumber);
  };

  const renderList = () => {
    if (typeof list !== 'undefined' && Object.keys(list).length > 0) {
      return Object.keys(list).map(id => {
        var data = list[id];
        var autoNumber = parseInt(id) + 1 + (pageNumber - 1) * limit;
        return (
          <div className="table_row border_t_1 border_color_1" key={id}>
            <div className="tabcel align_middle pad10">{autoNumber}</div>
            <div className="tabcel align_middle pad10">{data.first_name} {data.last_name}</div>
            <div className="tabcel align_middle pad10">{data.country_name ? data.country_name : 'N/A'}</div>
            <div className="tabcel align_middle pad10">{data.city_name ? data.city_name : 'N/A'}</div>
            <div className="tabcel align_middle pad10">{data.channel_name ? data.channel_name : 'N/A'}</div>
            <div className="tabcel align_middle pad10">{data.created_on}</div>
          </div>
        );
      });
    }
  };

  return (
    <Fragment>
      {showUILoader ? <Loader /> : ''}
      <div className="container_fluid topheading pad_lft_rht25 pad_top_bot15 text-start">
        <div className="row">
          <div className="col-xs">
            <div className="d-full-height justify-content-center fnt18 tu">Category Rateplan Mapping</div>
          </div>
        </div>
      </div>
      {flag ? (
        <div className={`alert_col posfixed pad10 tc fnt16 bld ${type === 'error' ? 'danger' : 'success'}`}>
          {message}
        </div>
      ) : ''}
      {checkRole('download_mapping') ? (
        <div className="container_fluid pad_lft_rht25 padtop10 bg2_12 boder_b_1 border_color_1">
          <div className="row gutters-5">
            <div className="col-xs-12 col-md-3 marg_bottom10">
              <div className="frm border_all_1 border_color_1">
                <span className="ficon pad_lft_rht10">
                  <i className="fa fa-chevron-down"></i>
                </span>
                <select
                  name="countryId"
                  className="input pad_lft_rht10"
                  value={params.countryId}
                  onChange={paramChange}
                >
                  <option value="">All</option>
                  {Object.keys(countryList).map((id, i) => (
                    <option key={i} value={countryList[id].country_id}>
                      {countryList[id].country}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-xs-12 col-md-3 marg_bottom10">
              <div className="frm border_all_1 border_color_1">
                <AsyncTypeahead
                  ref={cityTypeHead}
                  multiple={false}
                  inputProps={{ className: 'inputs' }}
                  id="city"
                  className="input"
                  isLoading={showSearchLoader}
                  options={cityList}
                  labelKey="city"
                  minLength={3}
                  align="justify"
                  onSearch={handleSearchCity}
                  placeholder={'City'}
                  filterBy={['city']}
                  selectHintOnEnter
                  onChange={selected => handleAsyncCity(selected, 'city')}
                  renderMenuItemChildren={(option, props) => (
                    <span key={option.city_id} id={option.city_id}>
                      {option.state ? option.city + ' ,' + option.state : option.city}
                    </span>
                  )}
                />
              </div>
            </div>
            <div className="col-xs-12 col-md-3 marg_bottom10">
              <div className="frm border_all_1 border_color_1">
                <span className="ficon pad_lft_rht10">
                  <i className="fa fa-chevron-down"></i>
                </span>
                <select
                  name="channelId"
                  className="input pad_lft_rht10"
                  value={params.channelId}
                  onChange={paramChange}
                >
                  <option value="0">OTA</option>
                  {Object.keys(ota).length > 0
                    ? Object.keys(ota).map(id => {
                        var data = ota[id];
                        return (
                          <option value={data.channel_id} key={id}>
                            {data.ota_name}
                          </option>
                        );
                      })
                    : ''}
                </select>
              </div>
            </div>
            <div className="col-xs-12 col-md-auto marg_bottom10">
              <div className="btn1 pad_top_bot7 pad_lft_rht15 cursor_p tc" onClick={sendRequest}>
                <i className="fa fa-filter marg_right7"></i>Send Request
              </div>
            </div>
            <div className="col-xs-12 col-md-auto marg_bottom10">
              <div className="btn1 pad_top_bot7 pad_lft_rht15 cursor_p tc" onClick={reset}>
                <i className="fa fa-repeat marg_right7"></i>Reset
              </div>
            </div>
          </div>
        </div>
      ) : ''}
      <div className="container_fluid pad_lft_rht20 padtop25 text-start">
        <div className="cover border_all_1 border_color_1">
          <div className="scrolly_auto">
            <div className="table_col table_fixed">
              <div className="table_row bg2_8">
                <div className="tabcel align_middle pad10 tu bld wdhpx50">S.No.</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx150">User Name</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx150">Country</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx150">City</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx150">Channel</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx100">Date</div>
              </div>
              {renderList()}
            </div>
          </div>
          {total === 0 && !showUILoader ? (
            <div className="cover pad30 border_t_1 border_color_1">
              <div className="ovr tc marg_bottom10">
                <div className="inline">
                  <img src="/images/no_result.png" alt="No Logs Found" />
                </div>
              </div>
              <div className="ovr tc fnt16 bld">No result Found</div>
            </div>
          ) : ''}
        </div>
        {total > limit ? (
          <div className="cover tc margtop15">
            {/* <Pagination
              activePage={pageNumber}
              itemsCountPerPage={limit}
              totalItemsCount={total}
              pageRangeDisplayed={5}
              onChange={handlePageChange}
            /> */}
          </div>
        ) : ''}
      </div>
    </Fragment>
  );
};

export default DownloadMapping;
